import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { useStore } from 'core/store';
import useSession from 'core/hooks/use-session';
import ValueField from 'core/components/value-field';
import { addressFormatter } from 'core/helpers/formatters';
import AdditonalPhoneNumbers from '../additional-phone-numbers';
import { AccountAccessActions } from '../account-access-actions';
import useStyles from './account-details-display.styles';

const AccountDetailsDisplay = () => {
  const { account } = useStore();
  const classes = useStyles();
  const { canEditPolicies, viewOnly, isAgency } = useSession();

  const inviterLabel = ({ firstName, lastName, id }) =>
    id || firstName ? (
      <Link to={`/customer/${id}`} className={classes.inviterLink}>
        {firstName && lastName ? `${firstName} ${lastName}` : id}
      </Link>
    ) : (
      'No Referrer'
    );

  return (
    <>
      <ValueField value={`${account.fname} ${account.lname}`} copyable />
      <ValueField
        label="Mailing Address"
        value={(account.mailingAddress && addressFormatter(account.mailingAddress)) || ''}
      />
      <ValueField label="Email" value={account.email} copyable />
      <ValueField label="Primary Phone" value={account.phoneNumber} />
      <AdditonalPhoneNumbers />
      <ValueField label="Member Since" value={new Date(account.created).toLocaleDateString()} />
      {!isAgency && <ValueField label="Member Affinity Code" value={account.memberAffinityCode || '—'} />}
      {(canEditPolicies || viewOnly) && <ValueField label="Referred By" value={inviterLabel(account.inviter)} />}
      <AccountAccessActions />
    </>
  );
};

export default observer(AccountDetailsDisplay);
